<template>
  <div style="height: 100%">
    <div
      class="rms-container"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <!-- 搜索 -->
      <div class="search">
        <!-- 反馈原因 -->
        <div class="search-checkbox" v-if="overdueCheckbox.length>0">
            <div class="scroll-wrapper">
                <el-checkbox-group v-model="overdueDescsAll" size="small" class="checkbox-all">
                    <el-checkbox-button label="全部" @change="overdueAllChange">全部</el-checkbox-button>
                </el-checkbox-group>
                <el-checkbox-group v-model="formInline.overdueDescs" size="small" @change="overdueChange">
                    <el-checkbox-button v-for="item in overdueCheckbox" :label="item" :key="item">{{item}}</el-checkbox-button>
                </el-checkbox-group>
            </div>
        </div>
        <!-- 反馈原因 end -->
        <el-row :gutter="12" style="margin-bottom: 10px;">
            <el-col :span="8">
                <el-select
                    v-model="formSet.feedbackSelect"
                    placeholder="全部"
                    filterable
                    clearable
                    @change="changeFeedback(formSet.feedbackSelect)"
                >
                  <el-option value = "已反馈" lable = "已反馈"></el-option>
                  <el-option value = "未反馈" lable = "未反馈"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-select
                    v-model="formInline.overDueMonthDesc"
                    placeholder="全部"
                    clearable
                >
                  <el-option value="M0" label="信用期内"></el-option>
                  <el-option value="M1+" label="逾期M1+"></el-option>
                  <el-option value="M4+" label="逾期M4+"></el-option>
                  <el-option value="M6+" label="逾期M6+"></el-option>
                  <el-option value="M12+" label="逾期M12+"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-select
                    v-model="formInline.minDmbtr"
                    placeholder="全部"
                    clearable
                >
                  <el-option value=10000 label="金额≥1万"></el-option>
                  <el-option value=30000 label="金额≥3万"></el-option>
                  <el-option value=50000 label="金额≥5万"></el-option>
                  <el-option value=100000 label="金额≥10万"></el-option>
                  <el-option value=200000 label="金额≥20万"></el-option>
                  <el-option value=300000 label="金额≥30万"></el-option>
                  <el-option value=500000 label="金额≥50万"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-input placeholder="客户订单号/销售单号/SP供应商" v-model="formInline.queryStr" size="medium">
          <el-button slot="append" size="small" @click="query()">查询</el-button>
        </el-input>
      </div>
      <div style="height: 173px;"></div>

      <!-- 列表 -->
      <div class="list-container" v-if="tableList.length > 0">
        <el-card class="item" v-for="(item, index) in tableList" :key="index">
          <div slot="header" class="title">
            <div class="cell cell-l">{{ item.customerpono }}</div>
            <div class="cell cell-r">{{ item.overdueDay }}天</div>
          </div>
          <div class="content">
            <div class="text">
              <div>{{ item.vbeln }}</div>
            </div>
            <div class="text">
              <div>{{ item.kunnrT }}</div>
            </div>
            <div class="text row flex-justify-between">
              <div class="cell-l"></div>
              <div class="cell-r">{{ item.amount | formatYuan }}</div>
            </div>
            <div class="text row" v-if="formInline.type == '2'">
              <div class="cell-l">{{ item.xref2 }}</div>
              <div class="cell-r">{{ item.kunpyName }}</div>
            </div>
            <div class="text">
              <div>{{ item.feedbackRemark }}</div>
              <div class="small">{{ item.feedbackTime | formatDay }}</div>
            </div>
          </div>
          <div class="btn">
            <el-button size="mini" @click="openDetail(item)">明细</el-button>
            <el-button size="mini" @click="openFeedback(item)">反馈</el-button>
          </div>
        </el-card>
      </div>

      <!-- 加载更多 -->
      <div class="scroll-more" v-if="loading">加载中...</div>
      <div class="scroll-more" v-if="tableList.length > 0 && listsClose">
        没有更多了
      </div>
      <el-empty
        description="暂无数据"
        v-if="tableList.length == 0 && listsClose"
      ></el-empty>

      <!-- 详情弹层 -->
      <el-dialog
        title="订单详情"
        class="revise-content"
        center
        :visible.sync="infoFlag"
        fullscreen
        :modal="false"
      >
        <v-RMSDetail :pageData="infoData" v-if="infoFlag"></v-RMSDetail>
      </el-dialog>

      <!-- 反馈弹层 -->
      <el-dialog
        title="反馈"
        class="revise-content"
        center
        :visible.sync="changeFlag"
        fullscreen
        :modal="false"
      >
        <v-RMSFeedback
          :pageData="changeData"
          @successFeedback="successFeedback"
          v-if="changeFlag"
        ></v-RMSFeedback>
      </el-dialog>
    </div>
    <!-- 水印 -->
    <v-Watermark
      v-if="watermarkContent"
      :content="watermarkContent"
    ></v-Watermark>
  </div>
</template>

<script>
import util from "../../../common/util";
import RMSDetail from "../../../components/RMS/detail";
import RMSFeedback from "../../../components/RMS/feedback";
import Watermark from "../../../components/RMS/watermark";
export default {
  name: "RMSH5List",
  components: {
    "v-RMSDetail": RMSDetail,
    "v-RMSFeedback": RMSFeedback,
    "v-Watermark": Watermark,
  },
  data() {
    return {
      uName: sessionStorage.getItem("UNAME"),
      //form
      formInline: {
        type: 1,
        userId: "",
        queryStr: "",
        overdueDescs: [], //反馈原因
      },
      //反馈原因
      overdueDescsAll: ['全部'],
      overdueList: {
        '1': ['未完全收货', '客户取消', '退货未核销', '符合开票条件', '客户不开票'],
        '2': ['发票未送达', '回款未匹配', '客户无预算', '提前开票', '其他原因', '发票丢失', '客户已回款', '已收票未挂账', '客户取消'],
      },
      overdueCheckbox: [],
      //反馈原因 end
      tableList: [], //列表
      //分页
      paginationConf: {
        pageNum: 0,
        pageSize: 15,
        pageTotal: 0,
      },
      loading: false,
      listsClose: false,
      infoFlag: false, //详情
      infoData: {}, //详情传参
      changeFlag: false, //反馈
      changeData: {}, //反馈传参
      watermarkContent: null, //水印
      formSet: {
        feedbackSelect: null,
      }
    };
  },
  filters: {
    formatDay(time) {
      return util.formatDate(time);
    },
    formatYuan(val) {
      let str = val ? val + "元" : "0.00元";
      return str;
    },
  },
  created() {
    this.watermarkContent =
      sessionStorage.getItem("NICKNAME") +
      (sessionStorage.getItem("MOBILE").toString() != "null"
        ? sessionStorage.getItem("MOBILE").slice(-4)
        : "");
    if (this.$route.query.type == "1") {
      document.title = "已送货未开票";
    } else {
      document.title = "已开票未回款";
    }
    this.formInline.type = this.$route.query.type;
    this.overdueCheckbox = this.overdueList[this.$route.query.type]; //反馈原因
  },
  methods: {
    // 初始化
    async init() {
      let res = await this.$api.receivableQyweixinList({
        ...this.formInline,
        ...this.paginationConf,
        ...this.$route.query,
      });
      if (res.code === 200 && res.result) {
        this.tableList = this.tableList.concat(res.result.list);
        this.paginationConf.pageTotal = res.result.totalCount;
        if (res.result.page >= res.result.totalPage) {
          this.listsClose = true;
        }
      } else {
        this.listsClose = true;
      }
    },
    // 查询
    query() {
      this.tableList = [];
      this.paginationConf.pageNum = 0;
      this.loading = false;
      this.listsClose = false;
      this.loadMore();
    },
    // 加载列表数据/滑到底部自动加载
    loadMore() {
      if (this.listsClose) {
        return false;
      }
      this.loading = true;
      setTimeout(async () => {
        this.paginationConf.pageNum += 1;
        await this.init();
        this.loading = false;
      }, 200);
    },
    // 反馈原因-选择全部
    overdueAllChange(val){
        if (val) {
            this.formInline.overdueDescs = [];
        };
        this.overdueDescsAll = ['全部'];
        this.query();
    },
    // 反馈原因-选择
    overdueChange(val){
        this.overdueDescsAll = [];
        this.query();
    },
    // 明细-查询明细列表
    async openDetail(obj) {
      let res = await this.$api.receivableQyweixinDetails({
        type: this.formInline.type,
        vbeln: obj.vbeln,
        queryStr: "",
        pageNum: 1,
        pageSize: 15,
      });
      if (res.code === 200) {
        if (res.result) {
          if (res.result.list.length > 1) {
            this.$router.push({
              path: "/RMS/H5/details",
              query: { type: this.formInline.type, vbeln: obj.vbeln },
            });
            return false;
          } else if (res.result.list.length == 1) {
            this.infoData = res.result.list[0];
            this.infoData.clientType = "mobile";
            this.infoFlag = true;
            return false;
          }
        }
        this.$message({
          message: "数据为空，请稍后再试",
          type: "warning",
        });
      }
    },
    changeFeedback(feedback) {
      if(feedback === '已反馈') {
        this.formInline.feedback = '1'
        return;
      }
      if (feedback === '未反馈') {
        this.formInline.feedback = '2'
        return;
      }
      this.formInline.feedback = '0'
    },
    // 反馈-打开弹窗
    openFeedback(obj) {
      // if (obj.ywybh != this.uName) {
      //   this.$message({
      //     message: "只可对业务员归属本人的订单进行反馈",
      //     type: "warning",
      //   });
      //   return false;
      // }
      this.changeData = obj;
      this.changeData.type = this.formInline.type;
      this.changeData.clientType = "mobile";
      this.changeFlag = true;
    },
    // 反馈-关闭
    successFeedback(flag) {
      this.changeFlag = false;
      if (flag) {
        this.query();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.rms-container {
  height: 100%;
  overflow-y: auto;
  position: relative;
  z-index: 2;
  .search {
    padding: 10px 15px;
    background-color: #fff;
    border-bottom: 1px solid #ececec;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    /deep/.el-input-group__append {
        background-color: #7B9CF7;
        color: #fff;
    }
  }
    .search-checkbox {
        background-color: #FAFAFA;
        padding: 20px 15px 10px;
        margin: -10px -15px 10px;
        .scroll-wrapper {
            width: 100%;
            overflow-x: auto;
            white-space: nowrap;
            &::-webkit-scrollbar {
                display: none;
            }
            /deep/.el-checkbox-group {
                display: inline-block;
                white-space: nowrap;
                .el-checkbox-button {
                    margin-left: 20px;
                    .el-checkbox-button__inner {
                        border: none;
                        border-radius: 50px;
                        box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.04);
                        padding-top: 12px;
                        padding-bottom: 12px;
                        color: #999;
                    }
                    &.is-checked {
                        .el-checkbox-button__inner {
                            background: #B6C9FF;
                            color: #4576FC;
                        }
                    }
                }
                &.checkbox-all {
                    .el-checkbox-button {
                        margin-left: 0;
                    }
                }
            }
        }
    }
  .list-container {
    margin: 0 10px;
    .item {
      margin-top: 10px;
      font-size: 14px;
      /deep/.el-card__header {
        padding: 0;
      }
      /deep/.el-card__body {
        padding: 0;
      }
      .title {
        height: 44px;
        line-height: 44px;
        padding: 0 15px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        .cell {
          padding: 0 2px;
          white-space: nowrap;
          &.cell-l {
            width: calc(~"100% - 70px");
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 16px;
          }
          &.cell-r {
            text-align: right;
            color: #d9001b;
          }
        }
      }
      .content {
        padding: 10px;
        .row {
          display: flex;
          &.flex-justify-between {
            justify-content: space-between;
          }
        }
        .text {
          line-height: 18px;
          padding: 3px 0;
          .small {
            color: #999;
          }
        }
        .cell-l {
          min-width: 90px;
        }
      }
      .btn {
        padding: 5px 10px 15px;
        text-align: right;
        .el-button {
            padding: 8px 10px;
            &+.el-button {
                margin-left: 20px;
            }
        }
      }
    }
  }
}
.scroll-more {
  padding: 15px 0;
  text-align: center;
  font-size: 14px;
  color: #5e6d82;
}
</style>
